import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  preEnrolResponse: "",
  preEnrolments: [],
  selectedPreEnrolment: {},
};

const preEnrolSlice = createSlice({
  name: "pre-enrol",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true;
    },
    preEnrolSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.preEnrolResponse = payload || {};
    },
    getPreEnrolSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.preEnrolments = payload || [];
    },
    getSinglePreEnrolSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.selectedPreEnrolment = payload || {};
    },
    preEnrolFail: (state, { payload }) => {
      state.isLoading = false;
      state.preEnrolResponse = payload || {};
    },
  },
});

const { reducer, actions } = preEnrolSlice;

export const {
  preEnrolSuccess,
  getPreEnrolSuccess,
  getSinglePreEnrolSuccess,
  isPending,
  preEnrolFail,
} = actions;

export default reducer;
